module.exports = __webpack_public_path__ + "img/createRoad.141e8aff.svg";